import encryption from '@sstdev/lib_encryption';
import { post } from 'lib_ui-services/src/http';
import { getProfile, saveProfile } from 'lib_ui-services/src/session/sessionCache';

const _p = {
    post,
    getProfile,
    saveProfile,
    UpdateServerWithNewPin
};
export const _private = _p;

/**
 * Update server with new PIN using secure identity silo endpoint
 * This replaces the direct user record access with a secure self-only endpoint
 */
async function UpdateServerWithNewPin(offlinePin, salt) {
    const url = '/api/identity/setPin';
    
    try {
        await _p.post(url, { offlinePin, salt });

        const profile = await _p.getProfile(false);
        await _p.saveProfile({ ...profile, offlinePin, salt }, true);

        return { success: true };
    } catch (error) {
        return { success: false, error };
    }
}

async function EncryptPin(pin) {
    const salt = Math.floor(Math.random() * 100000).toString();
    const encryptedPin = await encryption.bcrypt.encrypt(pin.toString() + salt);

    return { encryptedPin, salt };
}

export { UpdateServerWithNewPin, EncryptPin };